import { useLingui } from '@lingui/react/macro';
import { createFileRoute } from '@tanstack/react-router';
import { Button, toast } from '@utima/ui';

import { FormPage } from '@/components/page/FormPage';
import { AppSettings } from '@/constants/AppSettings';
import { ChatForm } from '@/features/chats/components/ChatForm';
import { copyToClipboard } from '@/lib/copyToClipboard';
import { trpc } from '@/services/trpc';

const populate = ['documentsCount', 'embeddingsCount', 'omnichannelConfig'];

export const Route = createFileRoute('/_baseLayout/chats/$chatId/edit')({
  component: ChatsEditPage,
  loader: async ({ context: { trpcUtils }, params: { chatId } }) =>
    trpcUtils.chats.findOne.ensureData({ id: chatId, populate }),
});

export function ChatsEditPage() {
  const { chatId } = Route.useParams();
  const { t } = useLingui();
  const [data] = trpc.chats.findOne.useSuspenseQuery({
    id: chatId,
    populate,
  });

  return (
    <FormPage
      title={`${t`Configuration`} - ${data.name}`}
      actions={
        <Button
          onClick={() => {
            copyToClipboard(
              `${AppSettings.playgroundUrl}/?chatId=${chatId}`,
            ).then(() => {
              toast.success(t`Copy link`, {
                description: t`Link was copied to clipboard`,
              });
            });
          }}
        >
          {t`Share`}
        </Button>
      }
      breadcrumbs={[
        { label: t`Agent` },
        {
          label: data.name,
          to: '/chats/$chatId/edit',
          params: { chatId },
        },
      ]}
    >
      {/* TODO FIX THIS TS ERROR WITH INFINITE INSTANTIATION */}
      <ChatForm data={data as any} />
    </FormPage>
  );
}
